module.exports = __webpack_public_path__ + "img/kudi.22c7147d.png";